import { useState, useEffect } from 'react'
import Main from "../../../layouts/Main"
import Card from "../../../components/Card"
import InputGroup from "../../../components/InputGroup"
import Loader from '../../../components/Loader'
import Pagination from '../../../components/Pagination'
import RequestPointItem from './RequestPointItem'
import BonusPointService from '../../../services/BonusPoint'
import Detail from '../Detail'
import Select, { components } from 'react-select'

const optionType = [
  { value: null, label: 'Semua' },
  { value: 'money', label: 'Pencairan Uang' },
  { value: 'reward', label: 'Penukaran Barang' },
]
const optionStatus = [
  { value: 'proses', label: 'Diproses' },
  { value: 'disetujui', label: 'Disetujui' },
  { value: 'selesai', label: 'Selesai' }
]

const CustomValueContainer = ({ children, ...props }) => {
  const selected = props.getValue();

  let displayLabel = props.selectProps.placeholder;
  if (selected.length === 1) {
    displayLabel = selected[0].label;
  } else if (selected.length > 1) {
    displayLabel = `${selected.length} Dipilih`;
  }

  return (
    <components.ValueContainer {...props}>
      <div>{displayLabel}</div>
      {selected.length > 1 && children}
    </components.ValueContainer>
  );
};

const RequestPoint = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [limit, setLimit] = useState(10)
  const [modal, setModal] = useState(false)
  const [dataDetail, setDataDetail] = useState(null)
  const [search, setSearch] = useState(null)
  const [type, setType] = useState(null)
  const [status, setStatus] = useState([])
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  useEffect(() => {
    setLoading(true)

    BonusPointService.request(pageNumber, limit, search, type, status, startDate, endDate)
      .then((res) => {
        setData(res.data.data)
        setTotalPage(res.data.total_page)
      })
      .catch((err) => {
        console.log(err)
      })

    setLoading(false)
  }, [pageNumber, limit, search, type, status, startDate, endDate])

  const changePageHandler = ({ selected }) => {
    setPageNumber(selected + 1)
  }

  const changeRowPerPage = (event) => {
    setPageNumber(1)
    setLimit(+event.target.value)
  };

  const searchHandler = (value) => {
    setPageNumber(1)
    setSearch(value === '' ? null : value)
  }

  const typeSelectHandler = (options) => {
    setType(options.value)
  }

  const statusSelectHandler = (options) => {
    setStatus(options.map(v => v.value))
  }

  const endDateHandler = (e) => {
    const value = e.target.value
    setEndDate(value)
  }

  const closeEditHandler = () => {
    setModal(false)
  }

  if (loading === true) {
    return <Loader />
  }

  return (
    <Main title="Pengajuan Pencairan Poin">
      {modal && (
        <Detail
          data={dataDetail}
          activeModal={modal}
          closeClick={closeEditHandler}
        />
      )}

      <Card col={'col-xl-12 col-lg-12'}>
        <div className="row justify-content-end">
          <div className="col-2">
            <h5 className="card-title mb-2 text-gray">Jenis</h5>
            <Select
              options={optionType}
              defaultValue={optionType[0]}
              onChange={typeSelectHandler}
            />
          </div>
          <div className="col-2">
            <h5 className="card-title mb-2 text-gray">Status</h5>
            <Select
              options={optionStatus}
              isMulti
              closeMenuOnSelect={false}
              onChange={statusSelectHandler}
              placeholder="Semua"
              hideSelectedOptions={false}
              components={{
                ValueContainer: CustomValueContainer,
                MultiValue: () => null,
              }}
            />
          </div>
          <div className="col-4">
            <h5 className="card-title mb-2 text-gray">Tanggal</h5>
            <div className="d-flex">
              <input
                className="form-control me-1" style={{ borderColor: '#CCCCCC' }}
                placeholder="MM/DD/YYYY"
                title="Tanggal Mulai"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
              <input
                className="form-control ms-1" style={{ borderColor: endDate < startDate && endDate ? 'red' : '#CCCCCC' }}
                placeholder="MM/DD/YYYY"
                title={endDate < startDate && endDate ? "Tanggal Akhir tidak valid" : "Tanggal Akhir" }
                type="date"
                value={endDate}
                onChange={endDateHandler}
                disabled={!startDate}
              />
            </div>
          </div>
          <div className="col-3">
            <h5 className="card-title mb-2" style={{color: 'transparent'}}>Search</h5>
            <InputGroup
              button="btn btn-primary"
              icon="fa fa-search"
              searchHandler={searchHandler}
              placeholder="Cari Mitra"
            />
          </div>
        </div>

        <div className="row mt-5 mb-5">
          <div className="col-12">
            <div className="table-responsive">
              <table className="table text-nowrap text-md-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="text-center">NO</th>
                    <th className="text-center">MITRA</th>
                    <th className="text-center">JENIS PENCAIRAN</th>
                    <th className="text-center">NOMINAL PENCAIRAN</th>
                    <th className="text-center">WAKTU PENGAJUAN</th>
                    <th className="text-center">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                {data.map((d, index) => (
                  <RequestPointItem 
                    key={d.id}
                    no={ index + (pageNumber === 1 ? 1 : limit * pageNumber - limit + 1) }
                    worker_id={d.worker_id}
                    worker_name={d.name}
                    nominal={d.point}
                    date={d.request_date}
                    status={d.status}
                    approve_by={d.approved_by}
                    approve_at={d.approved_at}
                    type={d.type}
                    setModal={setModal}
                    setDataDetail={setDataDetail}
                  />
                ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <p className="text-nowrap m-0">Row Per Page</p>
            <select
              className={`form-select text-dark`}
              onChange={changeRowPerPage}
              value={limit}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
            </select>
          </div>
          <Pagination pageCount={totalPage} changePage={changePageHandler} forcePage={pageNumber - 1}
          />
        </div>
      </Card>
    </Main>
  )
}

export default RequestPoint
